import React, { useMemo } from "react";
import { PageContextUtils, UrlUtils } from "../../../../utils";
import { HomeSectionMenuItem, Item } from "../../../../components/Menu";
import {
  LanguageSwitcherSelectors,
  UserContextSelectors
} from "../../../../redux/selectors";
import { CategoryType, CountryCodes } from "../../../../constants";
import { LocalizationMessages } from "../../../../localization/messages";
import { links } from "./Config.resource";
import { useCategoriesSetter } from "../../../../hooks";
import { useSelector } from "react-redux";
import { AppFeatures } from "../../../../constants/featureFlags";
import { useFeature } from "../../../../hooks/useFeature";
import { useAccountCommunicationHandlers } from "../../../../hooks";

const { contentLangId } = PageContextUtils.getLocalizationData();

const HomeSection = () => {
  const isVip = useSelector(UserContextSelectors.isVip);
  const lang = useSelector(LanguageSwitcherSelectors.lang);
  const isMadeForYouActive = useFeature(AppFeatures.MADE_FOR_YOU);
  const { openChallengesOrPromotions } = useAccountCommunicationHandlers();
  const isMobile = useSelector(UserContextSelectors.isMobile);
  var { country } = PageContextUtils.getGlobalizationData();
  const ALLOWED_CHALLENGE_COUNTRIES = [CountryCodes.Canada, CountryCodes.UK];
  const shouldShowChallenges =
    isMobile && ALLOWED_CHALLENGE_COUNTRIES.includes(country);

  const items = useMemo(
    () => ({
      home: new Item({
        URL: UrlUtils.getSEOUrl(links.home),
        title: LocalizationMessages.home,
        iconKey: "home"
      }),
      promotions: new Item({
        URL: UrlUtils.getSEOUrl(isVip ? links.promotionsVIP : links.promotions),
        title: isVip
          ? LocalizationMessages.promotionsVIP
          : LocalizationMessages.promotions,
        iconKey: "offers"
      }),
      challenges: new Item({
        title: LocalizationMessages.challengesMenuLabel,
        iconKey: "challenges"
      }),
      live: new Item({
        URL: UrlUtils.getSEOUrl(
          lang === "de" ? links.liveNowDE : links.liveNow
        ),
        title: LocalizationMessages.liveNow,
        iconKey: "live"
      }),
      recommendations: new Item({
        URL: UrlUtils.getSEOUrl(links.recommendations),
        title: LocalizationMessages.recommendations,
        iconKey: "recommendations"
      }),
      madeForYou: new Item({
        URL: UrlUtils.getSEOUrl(links.madeForYou[contentLangId]),
        title:
          contentLangId === "es"
            ? LocalizationMessages.madeForYouES
            : LocalizationMessages.madeForYou,
        iconKey: "recommendations"
      }),
      betFeed: new Item({
        URL: UrlUtils.getSEOUrl(links.betFeed),
        title: LocalizationMessages.betFeed,
        iconKey: "bet-feed"
      })
    }),
    [isVip, lang]
  );

  useCategoriesSetter(CategoryType.HomeSection, items);

  return (
    <>
      <HomeSectionMenuItem item={items.home} dataTestId="uc-home" />
      <HomeSectionMenuItem item={items.promotions} dataTestId="uc-offers" />
      {shouldShowChallenges && (
        <HomeSectionMenuItem
          item={items.challenges}
          dataTestId="uc-challenges"
          onClick={openChallengesOrPromotions}
        />
      )}
      <HomeSectionMenuItem item={items.live} dataTestId="uc-live" />
      {isMadeForYouActive ? (
        <HomeSectionMenuItem
          item={items.madeForYou}
          dataTestId="uc-made-for-you"
        />
      ) : (
        <HomeSectionMenuItem
          item={items.recommendations}
          dataTestId="uc-recommendations"
        />
      )}
      <HomeSectionMenuItem item={items.betFeed} dataTestId="uc-betFeed" />
    </>
  );
};

export default React.memo(HomeSection);
